import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  TableContainer,
  Table as BaseTable,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getComparator, stableSort } from '../../utils/sortable';
import TableHeader from './TableHeader';

const useStyles = makeStyles((theme) => ({
  tableCellContainer: {
    textOverflow: 'ellipsis', 
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 4,
    WebkitBoxOrient: 'vertical'
  }
}));

const Table = (props) => {
  const { columns, rows, keyField } = props;
  const defaultOrderBy = columns.find((col) => col.sortable);

  const classes = useStyles();

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState(
    defaultOrderBy ? defaultOrderBy.id : null
  );

  const handleRequestSort = useCallback(
    (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    },
    [orderBy, order]
  );

  return (
    <TableContainer>
      <BaseTable
        aria-labelledby="tableTitle"
        aria-label="enhanced table"
        size={props.size}
      >
        <TableHeader
          columns={columns}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={rows.length}
        />
        <TableBody>
          {!rows.length ? (
            <TableRow>
              <TableCell align="center" colSpan={columns.length}>
                Table is empty.
              </TableCell>
            </TableRow>
          ) : (
            stableSort(rows, getComparator(order, orderBy)).map(
              (row, index) => {
                return (
                  <TableRow key={row[keyField]}>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align || 'left'}>
                        <div className={classes.tableCellContainer}>
                          {row[column.id]}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                );
              }
            )
          )}
        </TableBody>
      </BaseTable>
    </TableContainer>
  );
};

Table.defaultProps = {
  size: 'medium',
  rows: [],
  keyField: 'id',
};

Table.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string,
      align: PropTypes.oneOf(['left', 'center', 'right']),
      sortable: PropTypes.bool,
    })
  ),
  size: PropTypes.oneOf(['small', 'medium']),
  rows: PropTypes.arrayOf(PropTypes.object),
  keyField: PropTypes.string, // the value rows[i][key] will be the key when react is mapping the table's rows
};

export default Table;
